import * as React from "react";
import { GetStaticProps, NextPage } from "next";
import groq from "groq";
import Layout from "../../components/Layout";
import sanityClient from "../../../client";
import { normalizeHeroImage } from "../../routes/images";
import RenderSections from "../../components/render-sections";
import {
	extractPropertyInfo,
	GenericPageProps,
	getSiteSettings,
} from "../../routes/common";
import { Service } from "../../types/generated/schema";

const ServiceDetailPage: NextPage<GenericPageProps> = ({
	pageData,
	config,
}) => {
	return (
		// @ts-ignore
		<Layout config={config} tags={pageData.seo}>
			{pageData.content && <RenderSections sections={pageData.content} />}
		</Layout>
	);
};

export default ServiceDetailPage;

const serviceQuery = groq`
*[_type == "service" && slug.current == $slug][0]{
  ...,
  seo {
    ...,
  	openGraphImage {
  		asset->
		}
	},
  content[] {
    ...,
    route->,
    image {
      asset->,
    	caption,
      alt
    },
    cta {
      ...,
      route->
    },
		packages[] {
      ...,
      route->
    },
		products[] {
      ...,
      accordionItems[] {
        ...,
        content[] {
          ...,
          markDefs[] {
            ...,
            _type == "internalLink" => {
              "slug": @->slug.current,
              "type": @->_type
            }
          }
        }
      }
    },
    accordionItems[] {
      ...,
      content[] {
        ...,
        markDefs[] {
          ...,
          _type == "internalLink" => {
            "slug": @->slug.current,
            "type": @->_type
          }
        }
      }
    },
    ctas[] {
      ...,
      route->
    },
    reviews[]-> {
      ...,
    },
    properties[],
    partners[]-> {
      ...,
    }
  }
}
`;

export const getStaticProps: GetStaticProps<GenericPageProps> = async ({
	params,
}) => {
	const sanityPageData = await sanityClient
		.fetch<Service>(serviceQuery, { slug: params.slug.toString() })
		.then((res) => ({ ...res }));

	const config = await getSiteSettings();

	if (!sanityPageData.content || !config) {
		return {
			notFound: true,
		};
	}

	const data = normalizeHeroImage(sanityPageData);
	const pageData = await extractPropertyInfo(data);

	return {
		props: {
			pageData,
			config,
		},
		revalidate: 60,
	};
};

export const getStaticPaths = async () => {
	const paths = await sanityClient.fetch(
		groq`*[_type == "service" && defined(slug.current)][].slug.current`,
	);

	return {
		paths: paths.map((slug) => ({ params: { slug } })),
		fallback: "blocking",
	};
};
